import * as ActionType from '../actions/generic'

function loader(state = false) {
  return state;
}

export function defaultLanguage(state = 'hindi', action) {
  switch (action.type) {
    case ActionType.SET_SELECTED_LANGUAGE:
      return action.defaultLanguage
    default:
      return state
  }
}

export function otherLanguage(state = 'english', action) {
  switch (action.type) {
    case ActionType.SET_SELECTED_LANGUAGE:
      return action.defaultLanguage === 'hindi' ? 'english':'hindi'
    default:
      return state
  }
}

export default loader;



// WEBPACK FOOTER //
// ./src/reducers/common.js